export default function Blob(dataArray) {
  return Buffer.from(dataArray[0]);
}
